"use strict";

//
if (typeof String.prototype.startsWith != 'function') {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function value(prefix) {
      return this.slice(0, prefix.length) === prefix;
    },
    writable: false,
    enumerable: false,
    configurable: false
  });
} //


if (typeof String.prototype.endsWith != 'function') {
  Object.defineProperty(String.prototype, 'endsWith', {
    value: function value(suffix) {
      return this.indexOf(suffix, this.length - suffix.length) !== -1;
    },
    writable: false,
    enumerable: false,
    configurable: false
  });
} //


if (typeof Array.prototype.remove != 'function') {
  Object.defineProperty(Array.prototype, 'remove', {
    value: function value(dx) {
      if (isNaN(dx) || dx > this.length) {
        return false;
      }

      for (var i = 0, n = 0; i < this.length; i++) {
        if (this[i] != this[dx]) {
          this[n++] = this[i];
        }
      }

      this.length -= 1;
    },
    writable: false,
    enumerable: false,
    configurable: false
  });
}

if (typeof Number.prototype.toCut != 'function') {
  Object.defineProperty(Number.prototype, 'toCut', {
    value: function value(num) {
      return parseInt(this.toFixed(20) * Math.pow(10, num)) / Math.pow(10, num);
    },
    writable: false,
    enumerable: false,
    configurable: false
  });
}

if (typeof String.prototype.hashCode != 'function') {
  Object.defineProperty(String.prototype, 'hashCode', {
    value: function value() {
      var hash = 0;
      if (this.length == 0) return hash;

      for (var i = 0; i < this.length; i++) {
        var char = this.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
      }

      return hash;
    },
    writable: false,
    enumerable: false,
    configurable: false
  });
}